const permissions = {
  listForms: 'OF001',
  addForm: 'OF002',
  editForm: 'OF003',
  removeForm: 'OF004',
  fillForm: 'OF006',
  answersFormReport: 'OF005',
  listAllUserAnswersForm: 'OF007',
  editFormResponse: 'OF008',
  editAllUserFormResponses: 'OF009',
  designFormReport: 'OF010',
  webiFormReport: 'OF011',
  // WD-972: vincular formularios a tipos de tarea, canales, clientes y sucursales
  linkForms: 'OF012'
};

export default permissions;
